export const siteContent = {
  hero: {
    h1Line1: 'O Melhor CSSBuy',
    h1Line2: 'Spreadsheet Atualizado em 2026',
    subtitle: 'Encontre os melhores links CSSBuy, produtos verificados e planilhas atualizadas diariamente para economizar em suas compras internacionais.',
    description: 'O CSSBuy Spreadsheet mais completo de Portugal. Descubra milhares de produtos organizados por categorias, vendedores confiáveis e links verificados. Economize tempo, encontre melhores preços e compre com mais segurança usando nossa planilha atualizada diariamente.',
    ctaMain: 'CSSBuy Sheet',
    ctaSecondary: 'Buy It Now',
    trustItems: [
      'Atualizado diariamente',
      'Links verificados',
      'Vendedores confiáveis',
      'Segurança nas compras',
      'Mais de 10.000 produtos',
    ],
    featureTags: ['Tênis', 'Roupas', 'Bolsas', 'Streetwear', 'Acessórios'],
  },
  eeat: {
    label: 'E-E-A-T & Confiança',
    title: 'Transparência e Resultados Reais',
    points: [
      'Atualizado diariamente',
      'Links verificados manualmente',
      'Vendedores auditados',
      'Suporte em Português',
    ],
    stats: [
      { value: '10.000+', label: 'Produtos' },
      { value: '15', label: 'Categorias' },
      { value: '1.200+', label: 'Reviews' },
      { value: '<2s', label: 'Velocidade' },
    ],
  },
  ctaArticle: {
    title: 'CSSBUY SPREADSHEET GUIDE 2026',
    subtitle: 'Aprenda a usar a planilha como profissional e economize em cada compra internacional.',
    buttonText: 'LER ARTIGO SEO',
  },
  featureGrid: {
    title: 'Por que esta planilha?',
    subtitle: 'Comparativo e vantagens exclusivas',
    features: [
      {
        title: 'Organização Superior',
        description: 'Categorização inteligente com mais de 15 categorias para encontrar exatamente o que você precisa em segundos.',
        icon: 'ri-dashboard-line',
      },
      {
        title: 'Links Verificados',
        description: 'Cada link é testado manualmente antes de ser adicionado. Garantimos que todos os produtos estejam disponíveis e ativos.',
        icon: 'ri-shield-check-line',
      },
      {
        title: 'Economia Real',
        description: 'Compare preços entre vendedores e encontre as melhores ofertas. Nossos usuários economizam em média 30% em cada compra.',
        icon: 'ri-money-dollar-circle-line',
      },
    ],
  },
  faq: {
    label: 'FAQ',
    title: 'Perguntas Frequentes',
    questions: [
      {
        id: 'Q1',
        question: 'O CSSBuy Spreadsheet é seguro?',
        category: '@Segurança',
        answer: 'Sim, nosso CSSBuy Spreadsheet é completamente seguro. Todos os links são verificados manualmente por nossa equipe antes de serem adicionados. Utilizamos apenas vendedores auditados e garantimos que cada produto listado atenda aos padrões de segurança do CSSBuy.',
      },
      {
        id: 'Q2',
        question: 'Como usar o CSSBuy Spreadsheet?',
        category: '@Tutorial',
        answer: 'Usar o CSSBuy Spreadsheet é muito simples. Basta selecionar a categoria desejada no menu de navegação, clicar no produto que lhe interessa, e você será redirecionado diretamente para a página de compra na plataforma CSSBuy. Todo o processo leva menos de 5 minutos.',
      },
      {
        id: 'Q3',
        question: 'Com que frequência a planilha é atualizada?',
        category: '@Atualizações',
        answer: 'Nossa planilha CSSBuy é atualizada diariamente. Nossa equipe monitora constantemente a disponibilidade de produtos, adiciona novos links e remove itens indisponíveis para garantir que você sempre encontre produtos ativos e preços atualizados.',
      },
      {
        id: 'Q4',
        question: 'Posso confiar nos vendedores listados?',
        category: '@Vendedores',
        answer: 'Absolutamente. Todos os vendedores em nosso CSSBuy Spreadsheet passam por um rigoroso processo de verificação. Avaliamos histórico de vendas, qualidade dos produtos e feedback de outros compradores antes de incluir qualquer vendedor em nossa lista.',
      },
      {
        id: 'Q5',
        question: 'O CSSBuy Spreadsheet funciona em Portugal?',
        category: '@Portugal',
        answer: 'Sim, o CSSBuy Spreadsheet é totalmente funcional para compradores em Portugal e em todo o mundo. Os links levam diretamente para as páginas de produtos no CSSBuy, que oferece envio internacional para Portugal com múltiplas opções de frete e rastreamento completo.',
      },
      {
        id: 'Q6',
        question: 'Quanto posso economizar usando a planilha?',
        category: '@Economia',
        answer: 'Em média, nossos usuários economizam entre 30% e 60% em comparação com compras diretas. O CSSBuy Spreadsheet agrega produtos de múltiplos vendedores, permitindo que você compare preços e encontre as melhores ofertas disponíveis no mercado.',
      },
    ],
  },
  footer: {
    tagline: 'O seu gateway para compras inteligentes no CSSBuy',
    columns: {
      categorias: {
        title: 'CATEGORIAS',
        links: [
          { name: 'Tênis', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
          { name: 'Moletons', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
          { name: 'Camisetas', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
        ],
      },
      recursos: {
        title: 'RECURSOS',
        links: [
          { name: 'Guia SEO', url: '/artigo/guia-cssbuy-spreadsheet' },
          { name: 'Links Verificados', url: 'https://kaspreadsheet.com' },
          { name: 'Comparativos', url: 'https://kaspreadsheet.com' },
        ],
      },
      legal: {
        title: 'LEGAL',
        links: [
          { name: 'Privacidade', url: 'https://kaspreadsheet.com' },
          { name: 'Termos', url: 'https://kaspreadsheet.com' },
          { name: 'Contato', url: 'https://kaspreadsheet.com' },
        ],
      },
      contato: {
        title: 'CONTATO',
        links: [
          { name: 'Suporte', url: 'https://kaspreadsheet.com' },
          { name: 'Email', url: 'https://kaspreadsheet.com' },
          { name: 'CSSBuy Sheet', url: 'https://kaspreadsheet.com' },
        ],
      },
    },
    copyright: '© 2026 cssbuyspreadsheet.guru. Todos os direitos reservados.',
  },
  articlePage: {
    title: 'Guia Definitivo CSSBuy Spreadsheet 2026',
    subtitle: 'Aprenda a dominar o CSSBuy Spreadsheet, encontre os melhores produtos e economize em cada compra internacional com nossa planilha atualizada diariamente.',
    ctaMain: 'Acessar CSSBuy Sheet',
    ctaBack: 'Voltar ao Início',
    chapters: [
      {
        num: '01',
        label: 'Capítulo 01',
        title: 'O que é o CSSBuy Spreadsheet?',
        points: [
          'Ferramenta de busca agregada que centraliza milhares de produtos de vendedores verificados em uma única planilha interativa.',
          'Produtos de vendedores chineses cuidadosamente selecionados, organizados por categorias como tênis, roupas, bolsas e acessórios.',
          'Filtros por categoria e preço que permitem encontrar exatamente o que você procura em segundos, sem perder tempo navegando em sites confusos.',
          'Atualização contínua de links garantindo que todos os produtos estejam sempre disponíveis para compra imediata.',
        ],
        stats: [
          { value: '50+', label: 'Vendedores' },
          { value: '10k+', label: 'SKUs' },
          { value: '15', label: 'Categorias' },
          { value: '100%', label: 'Free' },
        ],
        intro: 'O CSSBuy Spreadsheet é a ferramenta mais completa para quem deseja comprar produtos de qualidade diretamente de vendedores chineses. Nossa planilha reúne mais de 10.000 produtos verificados, organizados em 15 categorias diferentes, permitindo que você encontre exatamente o que procura sem complicações.',
        body: 'Diferente de outras soluções disponíveis no mercado, o CSSBuy Spreadsheet é mantido e atualizado diariamente por uma equipe dedicada que verifica manualmente cada link antes de adicioná-lo. Isso significa que você nunca encontrará links quebrados ou produtos indisponíveis. A planilha foi projetada pensando na experiência do usuário português, com todas as categorias e descrições em português para facilitar sua navegação.',
      },
      {
        num: '02',
        label: 'Capítulo 02',
        title: 'Como Usar a Planilha na Prática',
        points: [
          'Acesse a categoria desejada através do menu de navegação e explore os produtos disponíveis naquela seção específica.',
          'Verifique links ativos com um simples clique e seja redirecionado diretamente para a página de compra no CSSBuy.',
          'Compare preços em tempo real entre diferentes vendedores e encontre as melhores ofertas disponíveis no momento.',
          'Adicione ao carrinho CSSBuy e finalize sua compra com total segurança e proteção ao comprador.',
        ],
        stats: [
          { value: '3', label: 'Passos' },
          { value: '5 Min', label: 'Tempo' },
          { value: '-30%', label: 'Preço' },
          { value: '0', label: 'Risco' },
        ],
        intro: 'Usar o CSSBuy Spreadsheet é incrivelmente simples e intuitivo. Em apenas três passos, você pode encontrar, verificar e comprar produtos de alta qualidade com preços imbatíveis. Todo o processo leva menos de 5 minutos do início ao fim.',
        body: 'Comece selecionando uma das 15 categorias disponíveis no menu de navegação. Navegue pelos produtos listados e clique naquele que mais lhe interessar. Você será redirecionado diretamente para a página do produto no CSSBuy, onde poderá ver todos os detalhes, avaliações de outros compradores e finalizar sua compra com total segurança. A simplicidade do CSSBuy Spreadsheet é o que o torna a ferramenta preferida de milhares de compradores em Portugal.',
      },
      {
        num: '03',
        label: 'Capítulo 03',
        title: 'Segurança e Vendedores Verificados',
        points: [
          'Protocolo SSL em todos os links garantindo que suas informações de navegação e compra estejam sempre protegidas.',
          'Pagamentos via PayPal protegidos com política de proteção ao comprador em todas as transações realizadas.',
          'Sistema de reembolso ativo que garante seu dinheiro de volta caso o produto não corresponda ao anunciado.',
          'Comunidade de reviews transparente onde compradores reais compartilham suas experiências com cada vendedor.',
        ],
        stats: [
          { value: 'SSL', label: 'Ativo' },
          { value: 'PayPal', label: '✅' },
          { value: 'Garantido', label: 'Reembolso' },
          { value: '4.9/5', label: 'Trust' },
        ],
        intro: 'A segurança é nossa prioridade número um. O CSSBuy Spreadsheet foi desenvolvido com os mais rigorosos padrões de segurança, garantindo que cada link, cada vendedor e cada transação seja completamente confiável para nossos usuários.',
        body: 'Todos os links em nossa planilha utilizam protocolo SSL, o que significa que sua conexão é sempre criptografada e segura. Além disso, trabalhamos exclusivamente com vendedores verificados que passaram por nosso rigoroso processo de auditoria. Os pagamentos são processados através do PayPal, oferecendo proteção ao comprador em todas as transações. Caso algo não saia como esperado, nosso sistema de reembolso garante a devolução do seu dinheiro.',
      },
    ],
  },
};